import { config } from 'src/constants';

import auth from './auth';
import logger from './logger';
import notification from './notification';

const getMiddlewares = () => {
  const middlewares = [auth, notification];

  if (config.isDevEnv) {
    middlewares.push(logger);
  }

  return middlewares;
};

export default getMiddlewares;
